import { combineReducers } from 'redux';

import { reducer as analysisReducer } from './Analysis/combineReducer';
import { reducer as structureReducer } from './Structure/reducer';

export const reducer = combineReducers({
  analysis: analysisReducer,
  structure: structureReducer,
});